import { gatewayApi as api } from './gatewayApi';

export interface PartClass {
  Id?: number;
  Name: string;
  Description?: string;
  Active: boolean;
  CreatedDate?: string;
  ModifiedDate?: string;
}

export interface PartClassListResponse {
  data: PartClass[];
  total: number;
}

export interface PartClassSearchParams {
  page?: number;
  pageSize?: number;
  search?: string;
  active?: boolean;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const partClassApi = {
  getAll: (params?: PartClassSearchParams): Promise<PartClassListResponse> =>
    api.get('/partclass', params),

  getById: (id: number): Promise<PartClass> =>
    api.get(`/partclass/${id}`),

  create: (item: Omit<PartClass, 'Id'>): Promise<PartClass> =>
    api.post('/partclass', item),

  update: (id: number, item: Partial<PartClass>): Promise<PartClass> =>
    api.put(`/partclass/${id}`, item),

  delete: (id: number): Promise<{ success: boolean; message: string }> =>
    api.delete(`/partclass/${id}`),

  search: (params: PartClassSearchParams): Promise<PartClassListResponse> =>
    api.post('/partclass/search', params),

  bulkActivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/partclass/bulk-activate', { ids }),

  bulkDeactivate: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.put('/partclass/bulk-deactivate', { ids }),

  bulkDelete: (ids: number[]): Promise<{ success: boolean; message: string }> =>
    api.post('/partclass/bulk-delete', { ids }),

  getStatistics: (): Promise<{ total: number; active: number; inactive: number }> =>
    api.get('/partclass/statistics'),

  exportToCSV: (params?: PartClassSearchParams): Promise<Blob> =>
    api.getBlob('/partclass/export', { params }),

  validation: {
    validate: (item: Partial<PartClass>): string[] => {
      const errors: string[] = [];
      if (!item.Name || item.Name.trim().length === 0) errors.push('Name is required');
      else if (item.Name.trim().length < 2) errors.push('Name must be at least 2 characters');
      else if (item.Name.trim().length > 100) errors.push('Name must be less than 100 characters');
      if (item.Description && item.Description.length > 500) errors.push('Description must be less than 500 characters');
      if (item.Active === undefined || item.Active === null) errors.push('Active status is required');
      return errors;
    },
    validateBulk: (ids: number[]): string[] => {
      const errors: string[] = [];
      if (!ids || ids.length === 0) errors.push('Select at least one item');
      if (ids.length > 100) errors.push('Too many selected items');
      return errors;
    },
  },
};

export default partClassApi; 